document.addEventListener('DOMContentLoaded', function() {
  const mapping = {
    'inhaltsstoffe': 'inhaltsstoffe im detail',
    'wirkung': 'wirkungsweise und eigenschaften'
  };

  document.querySelectorAll('a.button--secondary[href="#details"]').forEach(function(link) {
    const linkText = link.textContent.trim().toLowerCase();

    let searchText = null;
    for (const key in mapping) {
      if (linkText.includes(key)) {
        searchText = mapping[key];
        break;
      }
    }
    if (!searchText) return;

    link.addEventListener('click', function(e) {
      const allDetails = document.querySelectorAll('#details details');
      let target = null;

      allDetails.forEach(function(details) {
        const title = details.querySelector('.accordion__title');
        if (title && title.textContent.trim().toLowerCase().includes(searchText)) {
          target = details;
        }
      });

      if (target) {
        e.preventDefault();
        target.setAttribute('open', '');
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});